import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const Admission = () => {
     useEffect(() => {
        document.title = 'Admission -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  Admission  </li> 
     <li>Admission Procedure
     </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>   Admission Procedure
              </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
             <p>Applicants interested in enrolling for the academic year 2026-27 can submit their applications through both online and offline mode.</p>
             <h3>Registration Guidelines</h3>
             <p><b>​Age Criteria:</b></p>
              <ul className="list">
                  <li> Applicants for Nursery class should be within the age group of 3 years as of 31st March. </li>
                  <li>Admissions to subsequent classes will follow government guidelines regarding age and will depend on the availability of vacant seats. </li>
             </ul>
             <p><b>​Entrance & Interaction Session:</b></p>
              <ul className="list">
             <li>Admissions except Nursery will be strictly based on the result of the admission test and merit. No entrance test will be conducted for class Nursery. However, the applicant along with the parent will be called for a short interaction session with the admission committee.</li>

             <li>Upon review of the registration forms, we will schedule meet and talk sessions for all the classes. A specific date for the interaction will be provided when the admission forms, along with all the necessary documents is submitted. Please note that we will not provide any other date to accommodate for meet and talk sessions if the child is absent on the given date.</li>
             </ul>
             <p><b>Admission Procedure</b></p>
              <ul className="list">
                <li>If your ward is selected, you will be informed through a phone call from our official numbers. Alternatively, you may also contact us on our official numbers, three days after the entrance exam has been conducted. </li>
                <li>Upon confirmation of admission, the admission fee must be paid within the following seven working days. Fees should be made online, with bank details provided upon confirmation.  </li>
                <li>After payment, please send a screenshot of the transaction, clearly stating your child's name, father's name and class, to the official email id spcsedisapp@gmail.com </li>
                <li>No student will be admitted without the original copy of the transfer certificate from the previous school and all the self-attested required documents. </li>
                <li>If the selected candidate does not take admission by paying the fee and completing other formalities within ten days, he/she will not be reconsidered for admission later on. </li>
                <li>The management has absolute freedom in the choice of candidate for admission in the institution. </li>
                <li>There will be no reconsideration for the candidates if once not selected. </li>
                <li>Incorrect or incomplete information automatically disqualifies the candidates. Each applicant will be issued only one form per year. </li>
                <li>Documents submitted with the application form will not be returned. </li>
                <li>The application form is non- transferable. </li>
             </ul>
             <p><b>​Documentation</b></p>
             <p>It is compulsory to attach the following documents along with the filled form.</p>
              <ul className="list">
                    <li> Two passport size photographs of the child and one family photograph. </li>
                    <li> Attested photocopy of Birth Certificate (child’s name should be mentioned). </li>
                    <li> A photocopy of Aadhaar card of the parents and the child. </li>
                    <li> Proof of residence is required if the current address is not listed on the parents' Aadhaar card. </li>
                    <li> A caste certificate must be submitted if the applicant belongs to OBC/ST/SC categories. </li>
                    <li> Photocopy of the previous class's mark sheet. </li>
                    <li> Family Identification Card (Parivar Pehchan Patra) is required if the applicant is a resident of Haryana. </li>
                    <li> Transfer certificate (original) to be submitted in the beginning of the session (April) along with the SRN and PEN. </li>
             </ul>
              <p><b>SCHOLARSHIP SCHEMES</b></p>
              <ul className="list">
<li>Candidates Securing 97% above in Class VI onwards entrance exam: 100% Tuition Fee Exemption.</li>
<li>National/ State level Sports and Arts first prize winners:100% Tuition Fee Exemption.</li>

              </ul>
              <p>State Level winner in sports and Arts: 50% Tuition Fee Exemption.</p>
             <p><b>FEE ONCE DEPOSITED WILL NOT BE REFUNDED IN ANY CASE.</b></p>
             <p><a className='bounce1 onlinereg' href='https://entab.online/R-SPCSFBD' target='_blank'>Click Here for Online Registration</a></p>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default Admission
